import React from 'react';
import SEO from '../components/SEO';
import HeroSection from '../components/HeroSection';
import ServicesSection from '../components/ServicesSection';
import WhyChooseUs from '../components/WhyChooseUs';
import AboutSection from '../components/AboutSection';
import BrandsSection from '../components/BrandsSection';
import FAQSection from '../components/FAQSection';
import PartsSection from '../components/PartsSection';
import ContactSection from '../components/ContactSection';
import CTASection from '../components/CTASection';

const HomePage = () => {
  return (
    <main data-testid="home-page">
      <SEO 
        title="BBM Appliances | Appliance Parts Nationwide | Repair Service PA & NJ"
        description="BBM Appliances - Buy appliance parts shipped nationwide to all 50 states! Same-day appliance repair service in Pennsylvania & New Jersey. Washer, dryer, refrigerator parts & repair. Call (855) 605-6034!"
        canonical="https://www.bbmappliances.com"
        keywords="buy appliance parts online, appliance parts nationwide, appliance parts USA, appliance repair Philadelphia, appliance repair NJ, washer parts, dryer parts, refrigerator parts, same day appliance repair, BBM Appliances"
      />
      <HeroSection />
      <ServicesSection />
      <WhyChooseUs />
      <AboutSection />
      <BrandsSection />
      <PartsSection />
      <FAQSection />
      <ContactSection />
      <CTASection />
    </main>
  );
};

export default HomePage;
